/* @flow */
import EventTracking from 'lib/EventTracking';
import User from 'entities/User';

let inProgress = false;
export const markAccountCreationStart = (user: ?User) => {
  if (!inProgress) {
    inProgress = true;
    const role = user ? user.getUserSelectedRole() : null;
    EventTracking.track('account.creation.start', { role });
  }
};

export const markSeenClasses = (user: User) => {
  if (inProgress) {
    const role = user.getUserSelectedRole();
    EventTracking.track('account.creation.finish', { role });
    inProgress = false;
  }
};



// WEBPACK FOOTER //
// ./src/utils/accountCompletionTracker.js